import { Spacing } from '@persona-id/design-tokens';
import { useState } from 'react';
import styled from 'styled-components';

import HelpIcon from 'dashboard/components-lib/HelpIcon';
import { ModuleMarkdown } from 'dashboard/modules/Markdown';
import Spacer from 'design-system/components/Spacer';
import { Heading, Label } from 'design-system/components/Text';
import TextArea from 'design-system/components/TextArea';

export interface MarkdownPanelProps {
  module: ModuleMarkdown;
  updateModule: (module: ModuleMarkdown) => void;
}

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  padding: ${Spacing[4]};
`;

const ResizableTextArea = styled(TextArea)`
  resize: vertical;
  height: 300px;
`;

const MarkdownPanel = ({ module, updateModule }: MarkdownPanelProps) => {
  const [markdownInput, setMarkdownInput] = useState(module?.markdown ?? '');

  const handleUpdateMarkdownInput = (markdownInput: string) => {
    setMarkdownInput(markdownInput);
    updateModule({
      ...module,
      markdown: markdownInput,
    });
  };

  return (
    <Container>
      <Spacer height={1} />
      <Heading size='sm'>Settings</Heading>
      <Spacer height={3} />
      <Label size='md' weight='bold'>
        Markdown Input<HelpIcon>To force a new line, add 2 new lines.</HelpIcon>
      </Label>
      <ResizableTextArea
        onChange={(e) => handleUpdateMarkdownInput(e.target.value)}
        value={markdownInput}
      />
    </Container>
  );
};

export default MarkdownPanel;
